import { render, staticRenderFns } from "./productPriceDialog.vue?vue&type=template&id=50cfd930&scoped=true"
import script from "./productPriceDialog.vue?vue&type=script&lang=js"
export * from "./productPriceDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50cfd930",
  null
  
)

export default component.exports